var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('time-logs-toolbar',{attrs:{"heading":"Time Logs"}}),_c('time-log-table',{attrs:{"show-job":true,"show-user":true,"show-user-classification":true,"filtering-tools":true,"collapse-buttons":true,"default-filter-values":{dateFrom: _vm.defaultDateFromFilter},"editable":_vm.editable}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }